import store from "@/providers/store"
import { ifAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"

/**
 * The fractional views on top of the plain authentication guard.
 *
 * A login with no candidate record can never become a fractional executive, so
 * it is sent straight to /welcome, which renders the dead end. Whether a
 * candidate is *already* fractional is not knowable from the session payload -
 * that only comes back as the `fractional_not_enabled` 403 - so the views
 * themselves redirect to /welcome when they get it.
 */
export async function ifFractional (to, from, next) {
  await ifAuthenticated(to, from, redirect => {
    // ifAuthenticated wants to send us somewhere else (login, consents,
    // user-info); its decision wins over ours.
    if (redirect) {
      next(redirect)
      return
    }

    const user = store.getters["Auth/getUserDetails"]

    if (user && Object.keys(user).length > 0 && !user.candidate) {
      next("/welcome")
      return
    }

    next()
  })
}
